import React, { Component } from 'react';
import {actions, connect} from 'mirrorx';
import DropboxController from '../controllers/dropbox-controller';

import OverwriteFileModal from './overwrite-file-modal';
import Pages from '../enums/pages';

import './form.css';

class SetSaveLocationModal extends Component {

	constructor() {
		super();

		this.state = {
			showModal: false,
			path: null,
			name: null,
			service: null
		}

		this.editFilename = this.editFilename.bind(this);
		this.cancel = this.cancel.bind(this);
		this.submit = this.submit.bind(this);
		this.chooseDropboxPath = this.chooseDropboxPath.bind(this);
		this.onDropboxChosen = this.onDropboxChosen.bind(this);
		this.initializeController = this.initializeController.bind(this);
		this.saveFile = this.saveFile.bind(this);

		this.controller = null;
	}

	cancel() {
		actions.layout.setPage(Pages.TEXTAREA);
	}
	submit() {
		this.initializeController();
		

		this.controller.isFile(this.state.path, this.state.name).then(result => {
			if (result === true) {
				this.refs.overwriteModal.activateModal();
			}
			else {
				this.saveFile();
			}
		});
	}

	saveFile() {
		this.initializeController();
		actions.layout.setIsLoading(true);
		this.controller.saveToDropbox(this.props.editor.text, this.state.path, this.state.name).then(meta => {
			actions.autosave.addRecentPath({
    			name: meta.name,
    			path: meta.path
    		});
    		actions.layout.setIsLoading(false);
    		actions.layout.setPage(Pages.TEXTAREA);
		});
		
	}

	editFilename(evt) {
		
		this.setState({
			name: evt.target.value
		});
	}

	onDropboxChosen(files) {
		this.initializeController();
		this.controller.getPathFromLink(files[0].link, files[0].isDir).then(meta => {
			this.setState({
				path: meta.path
			});
		});
	}

	chooseDropboxPath() {
	  window.Dropbox.choose({
        success: this.onDropboxChosen,
        folderselect: true
      });
	}

	initializeController() {
		if (this.controller == null) {
			this.controller = new DropboxController(this.props.services.dropboxClientId);
		}
	} 

	componentDidMount() {
		this.initializeController();
		this.setState({
			path: this.props.editor.file.path,
			name: this.props.editor.file.name,
			service: this.props.editor.file.service
		})
	}
	
	render() {
		return <div className='form-window'>
			<h1>Save New File</h1>
            	<hr />
            	<div className='form-block'>
	            	<label>Path: <small>{this.state.path}</small></label>
	            	<br/>
	            	<button className='btn' onClick={this.chooseDropboxPath}>Choose Path</button>
	            </div>
	            <div className='form-block'>
	            	<label>Filename: </label>
	            	<input defaultValue={this.props.editor.file.name} onChange={this.editFilename}/>
	            </div>
	            <div className='form-block'>
	            	<p>File will be saved as <span className='bold'>{this.state.path}{this.state.name}</span></p>
	            </div>
            	<hr/>
            	<div className='form-footer'>
            	<button className='btn' onClick={this.cancel}>
                Cancel
              </button>
              <button className='btn' onClick={this.submit}>
              Save
              </button>
              </div>
			<OverwriteFileModal ref='overwriteModal' 
				name={this.state.name} 
				path={this.state.path} 
				service={this.state.service}
				onClick={this.saveFile}/>
		</div>
	}
}

export default connect(state => {
  return {editor: state.editor,
  	services: state.services}
}, null, null, { withRef: true })(SetSaveLocationModal)


// WEBPACK FOOTER //
// ./src/components/set-save-location.js